import {
  BrowserSessionProvider,
  sessionAccessTokenProvider,
} from '@eluve/apollo-client';
import { Logger } from '@eluve/logger';

// One shared token provider per JS context — concurrent hard refreshes
// across all Apollo clients coalesce into a single SuperTokens refresh,
// avoiding rotation races with one-time refresh tokens.
export const { sessionActor, tokenProvider } = sessionAccessTokenProvider({
  sessionProvider: new BrowserSessionProvider(),
  logger: new Logger('shared-apollo-client'),
});
